import type { ProjectsType } from "@/entities/projects/model/types";
import Button from "@/shared/ui/buttons/Button";
import ProjectCardAlt from "@/shared/ui/cards/ProjectCardAlt";
import Typography from "@/shared/ui/Typography";
import * as React from "react";

export interface IProjectsListSectionProps {
    projects: ProjectsType;
}

export function ProjectsListSection({ projects }: IProjectsListSectionProps) {

    const [visibleCount, setVisibleCount] = React.useState(10);

    const handleLoadMore = () => {
        setVisibleCount(prev => prev + 10);
    };

    const visibleProjects = projects.slice(0, visibleCount);

    return (
        <div className="flex flex-col items-center gap-[32px]">
            {projects.length === 0 ? (
                <div className="flex justify-center items-center pt-[20px]">
                    <Typography className="text-black-50">
                        Объектов нет
                    </Typography>
                </div>
            ) : (
                <>
                    <div className='grid gap-[10px] grid-cols-1 md:grid-cols-2 lg:grid-cols-3 rounded-[10px] overflow-hidden'>
                        {visibleProjects.map(project => (
                            <ProjectCardAlt
                                key={project.id}
                                className='md:h-[340px] md:min-w-[340px] xl:h-[400px] xl:min-w-[400px]'
                                project={project}
                            />
                        ))}
                    </div>

                    {visibleCount < projects.length && (
                        <Button 
                            className='w-full flex justify-center text-[14px] md:text-[16px] hover:bg-blue-90'
                            onClick={handleLoadMore}
                        >
                            Показать ещё 10 объектов
                        </Button>
                    )}
                </>
            )}
        </div>
    );
}
